<ddc-camp-onglet-body *ngIf="currentCamp"
                      [idCamp]="idCamp" [codeModule]="moduleCode"
                      [campHistoModuleDerniereModification]="localCacheValue && localCacheValue.campHistoModuleDerniereModification">
  <div class="row">
    <div class="col-12">
      <button mat-raised-button class="ddc-button-primary ddc-button-top"
              (click)="checkDatesAndSave()"
              [disabled]="(isSaving) || (this.campForm.invalid && this.formAlreadySubmitted)">
        Enregistrer
      </button>
    </div>
  </div>
  <div class="row">
    <mat-form-field floatLabel="always" class="col-md-12">
      <mat-label ddcLabel labelKey="bdd.camp.libelle.infoGenerale"></mat-label>
      <input matInput [formControl]="campForm.get('libelle')" required id="libelle-input">
      <mat-error ddcMatError [control]="campForm.get('libelle')"></mat-error>
    </mat-form-field>

    <mat-form-field floatLabel="always" class="col-md-6">
      <mat-label ddcLabel labelKey="bdd.camp.statut"></mat-label>
      <mat-select [formControl]="campForm.get('statut')">
        <mat-option *ngFor="let status of CAMP_INFO_GENERALE_STATUS" [value]="status.value">
          {{status.text}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field floatLabel="always" class="col-md-3">
      <mat-label>
        <span ddcLabel labelKey="bdd.camp.dateDebut"></span>
        <span *ngIf="datesInterval && datesInterval.length > 0"> ({{convertToHumanDate(datesInterval[0])}})</span>
      </mat-label>
      <input matInput [matDatepicker]="dateDebutDatepicker"
             [formControl]="campForm.get('dateDebut')" required id="dateDebut-input">
      <mat-datepicker-toggle matSuffix [for]="dateDebutDatepicker"></mat-datepicker-toggle>
      <mat-datepicker #dateDebutDatepicker></mat-datepicker>
      <mat-error ddcMatError [control]="campForm.get('dateDebut')"></mat-error>
    </mat-form-field>

    <mat-form-field floatLabel="always" class="col-md-3">
      <mat-label>
        <span ddcLabel labelKey="bdd.camp.dateFin"></span>
        <span *ngIf="datesInterval && datesInterval.length > 0"> ({{convertToHumanDate(datesInterval[1])}})</span>
      </mat-label>
      <input matInput [matDatepicker]="dateFinDatepicker"
             [formControl]="campForm.get('dateFin')" required>
      <mat-datepicker-toggle matSuffix [for]="dateFinDatepicker"></mat-datepicker-toggle>
      <mat-datepicker #dateFinDatepicker></mat-datepicker>
      <mat-error ddcMatError [control]="campForm.get('dateFin')"></mat-error>
    </mat-form-field>
  </div>

  <mat-card class="ddc-card-with-title">
    <mat-card-title>
      <span ddcLabel labelKey="appli.camp.onglet.infoGenerale.carte.structures"></span>
    </mat-card-title>

    <mat-card-content>
      <div class="row">
        <div class="col-md-5" *ngIf="currentCamp._droitsUtilisateurCourant.modifierStructures">
          <div class="mat-elevation-z4 ddc-table-div-container">
            <table mat-table [dataSource]="structuresTableDataSource">
              <ng-container matColumnDef="libelle">
                <th mat-header-cell *matHeaderCellDef>
                  <span ddcLabel labelKey="appli.camp.onglet.infoGenerale.structures.structure.libelle"></span>
                </th>
                <td mat-cell *matCellDef="let structure"> {{structure.libelle}} </td>
              </ng-container>

              <ng-container matColumnDef="ajouter">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let structure; let i = index;">
                  <button
                    mat-flat-button class="ddc-button-primary"
                    (click)="ajouterStructuresDisponiblesSelectionnes(i)"
                    [disabled]="isSaving">
                    <i class="material-icons">add_circle</i>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="structuresTableDisplayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: structuresTableDisplayedColumns;"></tr>
            </table>
          </div>
        </div>

        <div [ngClass]="currentCamp._droitsUtilisateurCourant.modifierStructures ? 'col-md-7' : 'col-12'">
          <div class="mat-elevation-z4 ddc-table-div-container">
            <table mat-table [dataSource]="campStructuresTableDataSource">
              <ng-container matColumnDef="libelle">
                <th mat-header-cell *matHeaderCellDef>
                  <span ddcLabel labelKey="bdd.campStructure.structure.libelle"></span>
                </th>
                <td mat-cell *matCellDef="let campStructure"> {{campStructure.get('structure').value.code}} - {{campStructure.get('structure').value.libelle}} </td>
              </ng-container>

              <ng-container matColumnDef="organisatrice">
                <th mat-header-cell *matHeaderCellDef>
                  <span ddcLabel labelKey="bdd.campStructure.organisatrice"></span>
                </th>
                <td mat-cell *matCellDef="let campStructure">
                  <mat-checkbox
                    [disabled]="!currentCamp._droitsUtilisateurCourant.modifierStructures"
                    (change)="$event ? toggleFlagOrganisatrice(campStructure) : null"
                    [checked]="campStructure.get('organisatrice').value === true ? true : false"
                  ></mat-checkbox>
                </td>
              </ng-container>

              <ng-container matColumnDef="supprimer">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let campStructure; let i = index;">
                  <button *ngIf="currentCamp._droitsUtilisateurCourant.modifierStructures"
                          mat-flat-button color="warn"
                          (click)="supprimerCampStructureSelectionne(i)"
                          [disabled]="isSaving">
                    <i class="material-icons">remove_circle</i>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="campStructuresTableDisplayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: campStructuresTableDisplayedColumns;"></tr>
            </table>
          </div>
          <mat-error *ngIf="campForm.get('campStructures').errors">
            {{campForm.get('campStructures').errors.errorMessage}}
          </mat-error>
        </div>
      </div>

      <div class="row">
        <div class="col-md-5">
          <div class="row">
            <mat-form-field floatLabel="always" class="col">
              <mat-label ddcLabel labelKey="appli.camp.onglet.infoGenerale.ajouterStructureParCode"></mat-label>
              <input matInput type="number" [formControl]="codeEntryForm.get('structure')">
              <mat-error *ngIf="codeEntryForm.get('structure').errors">
                {{codeEntryForm.get('structure').errors.errorMessage}}
              </mat-error>
              <mat-hint>Entrez 9 chiffres</mat-hint>
            </mat-form-field>

            <div class="col-auto ddc-textfield-btn-div">
              <button mat-raised-button
                      type="button"
                      [disabled]="disableCodeSubmitButton(codeEntryForm.get('structure'))"
                      (click)="addStructureByCodeEntry()"
                      class="ddc-button-primary"><i class="material-icons">add_circle</i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Block Informations pour la télédéclaration, contains the information of jeanes. This block is displayed for the camp of type 8-17 -->
  <ng-container
    *ngIf="currentCamp.typeCamp.codeGroupeCamp === TypeCampGroupEnum.HUIT_DIXSEPT"
  >
    <mat-card class="ddc-card-with-title">
      <mat-card-title>
        <span ddcLabel labelKey="appli.camp.onglet.infoGenerale.carte.participants"></span>
      </mat-card-title>
      <mat-card-content>
        <div ddcLabel labelKey="appli.camp.onglet.infoGenerale.participants.description" class="ddc-appli-description"></div>
        <div *ngIf="campForm.get('camp817').errors; let errorMessage" class="row">
          <div class="col-12">
            <span class="ddc-error-message">
            <span [innerHTML]="errorMessage.message"></span>
            </span>
          </div>
        </div>
        <div class="row">
          <mat-form-field floatLabel="always" class="col-md-4">
            <mat-label ddcLabel labelKey="bdd.camp817.previsionNbreAnimateurs"></mat-label>
            <input matInput type="number" [formControl]="campForm.get('camp817.previsionNbreAnimateurs')">
            <mat-error ddcMatError [control]="campForm.get('camp817.previsionNbreAnimateurs')"></mat-error>
          </mat-form-field>

          <mat-form-field floatLabel="always" class="col-md-4">
            <mat-label ddcLabel labelKey="bdd.camp817.previsionNbreEquipes"></mat-label>
            <input matInput type="number" [formControl]="campForm.get('camp817.previsionNbreEquipes')">
            <mat-error ddcMatError [control]="campForm.get('camp817.previsionNbreEquipes')"></mat-error>
          </mat-form-field>
        </div>

        <div class="row">
          <mat-form-field floatLabel="always" class="col-md-4">
            <mat-label ddcLabel labelKey="bdd.camp817.previsionNbreParticipants"></mat-label>
            <input matInput type="number" [formControl]="campForm.get('camp817.previsionNbreParticipants')">
            <mat-error ddcMatError [control]="campForm.get('camp817.previsionNbreParticipants')"></mat-error>
          </mat-form-field>

          <mat-form-field floatLabel="always" class="col-md-4">
            <mat-label ddcLabel labelKey="bdd.camp817.previsionNbreFilles"></mat-label>
            <input matInput type="number" [formControl]="campForm.get('camp817.previsionNbreFilles')">
            <mat-error ddcMatError [control]="campForm.get('camp817.previsionNbreFilles')"></mat-error>
          </mat-form-field>

          <mat-form-field floatLabel="always" class="col-md-4">
            <mat-label ddcLabel labelKey="bdd.camp817.previsionNbreGarcons"></mat-label>
            <input matInput type="number" [formControl]="campForm.get('camp817.previsionNbreGarcons')">
            <mat-error ddcMatError [control]="campForm.get('camp817.previsionNbreGarcons')"></mat-error>
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>


  <!-- Block Génération du dossier camp -->
  <mat-card class="ddc-card-with-title">
    <mat-card-title>
      <span ddcLabel labelKey="appli.camp.onglet.infoGenerale.carte.generationDossierCamp"></span>
    </mat-card-title>
    <mat-card-content>
      <div ddcLabel labelKey="appli.camp.onglet.infoGenerale.generationDossierCamp.description"
           class="ddc-appli-description"></div>
      <div class="row">
        <div class="col-12">
          <button
            mat-raised-button class="ddc-button-primary ddc-button-right"
            (click)="generatePdf()" [disabled]="(isSaving)">
            Générer PDF
          </button>
        </div>
      </div>
      <ddc-camp-fichier-genere
        [idCamp]="idCamp"
        [generatedFiles]="fichiersDossierCamp"
        [titleLabelKey]="'appli.camp.onglet.infoGenerale.generationDossierCamp.pieceJointe.title'"
      >
      </ddc-camp-fichier-genere>
    </mat-card-content>
  </mat-card>

  <mat-card class="ddc-card-with-title" *ngIf="currentCamp.typeCamp.codeGroupeCamp == TypeCampGroupEnum.COMPAGNON">
    <mat-card-title>
      <span ddcLabel labelKey="appli.camp.onglet.infoGenerale.carte.accompagnateursCompagnons"></span>
    </mat-card-title>
    <mat-card-content>
      <div ddcLabel labelKey="appli.camp.onglet.infoGenerale.accompagnateursCompagnons.description"
           class="ddc-appli-description"></div>
      <div class="row">
        <div class="col-md-5">
          <div class="row">
            <mat-form-field floatLabel="always" class="col">
              <input matInput type="number" placeholder="Accompagnateur Compagnon"
                     [formControl]="codeEntryForm.get('ac')">
              <mat-hint>Entrez 9 chiffres</mat-hint>
              <mat-error ddcMatError [control]="codeEntryForm.get('ac')"></mat-error>
            </mat-form-field>

            <div class="col-auto ddc-textfield-btn-div">
              <button [disabled]="disableCodeSubmitButton(codeEntryForm.get('ac'))" mat-raised-button
                      (click)="getAdherentByCode(TypeSoutienEnum.ACCOM_COMP,codeEntryForm.get('ac'))"
                      type="button" class="ddc-button-primary">
                <i class="material-icons">search</i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-7 ddc-margin-auto">
          <div class="row ddc-row-adherent-soutien" *ngFor="let adherent of campAdherentSoutiensData[TypeSoutienEnum.ACCOM_COMP]; let i = index">
            <ng-container *ngIf="campAdherentSoutiensData[TypeSoutienEnum.ACCOM_COMP].length > 0">
              <div class="col ddc-margin-auto" *ngIf="campAdherentSoutiensData[TypeSoutienEnum.ACCOM_COMP].length > 0">
                {{adherent?.prenom}}
                {{adherent?.nom}}
                {{adherent?.telephonePortable}}
                {{adherent?.email}}
              </div>

              <div class="col-auto ddc-textfield-btn-div">
                <button mat-raised-button class="mat-warn"
                        (click)="supprimeCampAdherentSoutien(adherent, TypeSoutienEnum.ACCOM_COMP)">
                  <i class="material-icons">remove_circle</i>
                </button>
              </div>
            </ng-container>
          </div>
          </div>
        </div>
    </mat-card-content>
  </mat-card>

  <!-- Block Equipier en soutien -->
  <mat-card
    class="ddc-card-with-title"
    *ngIf="
      currentUser && (
      currentUser.modifierInterlocAP ||
      currentUser.isCOMMAR ||
      currentUser.isCMPP ||
      currentUser.isEPA ||
      currentUser.isEPANational ||
      currentUser.modifierInterlocLOCAL ||
      campAdherentSoutiensData[TypeSoutienEnum.AP] ||
      campAdherentSoutiensData[TypeSoutienEnum.MARIN] ||
      campAdherentSoutiensData[TypeSoutienEnum.INTERNATIONAL] ||
      campAdherentSoutiensData[TypeSoutienEnum.VAO] ||
      campAdherentSoutiensData[TypeSoutienEnum.LOCAL]
    )"
  >
    <mat-card-title>
      <span ddcLabel labelKey="appli.camp.onglet.infoGenerale.carte.equipiers"></span>
    </mat-card-title>
    <mat-card-content>
      <div ddcLabel labelKey="appli.camp.onglet.infoGenerale.equipiers.description" class="ddc-appli-description"></div>
      <div class="row" *ngIf="currentUser.modifierInterlocAP">
        <div class="col-md-5">
          <div class="row">
            <mat-form-field floatLabel="always" class="col">
              <input matInput type="number" placeholder="Soutiens territoriaux (soutien pédagogique, ETI...)"
                     [formControl]="codeEntryForm.get('ap')">
              <mat-hint>Entrez 9 chiffres</mat-hint>
              <mat-error ddcMatError [control]="codeEntryForm.get('ap')"></mat-error>
            </mat-form-field>

            <div class="col-auto ddc-textfield-btn-div">
              <button [disabled]="disableCodeSubmitButton(codeEntryForm.get('ap'))" mat-raised-button
                      (click)="getAdherentByCode(TypeSoutienEnum.AP,codeEntryForm.get('ap'))"
                      type="button" class="ddc-button-primary">
                <i class="material-icons">search</i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-7 ddc-margin-auto">
            <div class="row ddc-row-adherent-soutien" *ngFor="let adherent of campAdherentSoutiensData[TypeSoutienEnum.AP]; let i = index">
              <div *ngIf="campAdherentSoutiensData[TypeSoutienEnum.AP].length > 0" class="col ddc-margin-auto">
                <div class="col-auto ddc-textfield-btn-div">
                  {{adherent.prenom}}
                  {{adherent.nom}}
                  <span class="ddc-margin-info link"><a href="tel:{{adherent?.telephonePortable}}">{{adherent?.telephonePortable}}</a></span>
                  <span class="ddc-margin-info link"><a href="mailto:{{adherent?.email}}">{{adherent?.email}}</a></span>
                  <div *ngIf="campAdherentSoutiensData[TypeSoutienEnum.AP].length > 0" class="col-auto ddc-textfield-btn-div">
                    <button mat-raised-button class="mat-warn"
                            (click)="supprimeCampAdherentSoutien(adherent, TypeSoutienEnum.AP)">
                      <i class="material-icons">remove_circle</i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>

      <div class="row ddc-padding-vertical"
           *ngIf="!currentUser.modifierInterlocAP">
        <div class="col-12 ddc-margin-auto">
          <div class="ddc-read-only-data-container">
            <span class="ddc-label">Soutiens territoriaux (soutien pédagogique, ETI...) : </span>
            <ng-container *ngFor="let adherents of campAdherentSoutiensData[TypeSoutienEnum.AP]">
              <span class="ddc-value-read-only"> {{adherents?.prenom}} {{adherents?.nom}}</span>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="currentUser && currentUser.modifierInterlocLOCAL">
        <div class="col-md-5">
          <div class="row">
            <mat-form-field floatLabel="always" class="col">
              <input matInput type="number" placeholder="Soutiens locaux" [formControl]="codeEntryForm.get('local')">
              <mat-hint>Entrez 9 chiffres</mat-hint>
              <mat-error ddcMatError [control]="codeEntryForm.get('local')"></mat-error>
            </mat-form-field>

            <div class="col-auto ddc-textfield-btn-div">
              <button [disabled]="disableCodeSubmitButton(codeEntryForm.get('local'))"
                      (click)="getAdherentByCode(TypeSoutienEnum.LOCAL,codeEntryForm.get('local'))"
                      type="button" mat-raised-button class="ddc-button-primary">
                <i class="material-icons">search</i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-7 ddc-margin-auto">
          <div class="row ddc-row-adherent-soutien" *ngFor="let adherent of campAdherentSoutiensData[TypeSoutienEnum.LOCAL]; let i = index">
            <div *ngIf="campAdherentSoutiensData[TypeSoutienEnum.LOCAL]?.length > 0" class="col">
              {{adherent?.prenom}}
              {{adherent?.nom}}
              <span class="ddc-margin-info"><a href="tel:{{adherent?.telephonePortable}}">{{adherent?.telephonePortable}}</a></span>
              <span class="ddc-margin-info"><a href="mailto:{{adherent?.email}}">{{adherent?.email}}</a></span>

              <div *ngIf="campAdherentSoutiensData[TypeSoutienEnum.LOCAL].length > 0" class="col-auto ddc-textfield-btn-div">

                <button mat-raised-button class="mat-warn button-remove"
                        (click)="supprimeCampAdherentSoutien(adherent, TypeSoutienEnum.LOCAL)">
                  <i class="material-icons">remove_circle</i>
                </button>
              </div>
            </div>
          </div>
        </div>
        </div>


      <div class="row ddc-padding-vertical"
           *ngIf="!currentUser.modifierInterlocLOCAL && campAdherentSoutiensData[TypeSoutienEnum.LOCAL]?.length > 0">
        <div class="col-12 ddc-margin-auto">
          <div class="ddc-read-only-data-container">
            <span class="ddc-label">Soutiens locaux : </span>
            <ng-container *ngFor="let adherents of campAdherentSoutiensData[TypeSoutienEnum.LOCAL]">
                <span class="ddc-value-read-only">
                  {{adherents?.prenom}} {{adherents?.nom}}
                </span>
            </ng-container>
          </div>
        </div>
      </div>

      <ng-container
        *ngIf="
          isCampModulesActive(currentCamp, [CampModuleEnum.INTERNATIONAL_8_17, CampModuleEnum.INTERNATIONAL_COMP, CampModuleEnum.ACCUEIL_ETRANGER]) ||
          isCampModulesActive(campAdminstrationModules, [CampModuleEnum.INTERNATIONAL_8_17, CampModuleEnum.INTERNATIONAL_COMP, CampModuleEnum.ACCUEIL_ETRANGER])
        "
      >
        <div class="row" *ngIf="currentUser.isCMPP">
          <div class="col-md-5">
            <div class="row">
              <mat-form-field floatLabel="always" class="col">
                <input matInput type="number" placeholder="Soutiens département international" [formControl]="codeEntryForm.get('international')">
                <mat-hint>Entrez 9 chiffres</mat-hint>
                <mat-error ddcMatError [control]="codeEntryForm.get('international')"></mat-error>
              </mat-form-field>

              <div class="col-auto ddc-textfield-btn-div">
                <button [disabled]="disableCodeSubmitButton(codeEntryForm.get('international'))"
                        (click)="getAdherentByCode(TypeSoutienEnum.INTERNATIONAL,codeEntryForm.get('international'))"
                        type="button" mat-raised-button class="ddc-button-primary">
                  <i class="material-icons">search</i>
                </button>
              </div>
            </div>
          </div>

          <div class="col-md-7 ddc-margin-auto">
              <div class="row ddc-row-adherent-soutien" *ngFor="let adherent of campAdherentSoutiensData[TypeSoutienEnum.INTERNATIONAL]; let i = index">
                <div *ngIf="campAdherentSoutiensData[TypeSoutienEnum.INTERNATIONAL]?.length > 0" class="col">
                {{adherent?.prenom}}
                {{adherent?.nom}}
                  <span class="ddc-margin-info"><a href="tel:{{adherent?.telephonePortable}}">{{adherent?.telephonePortable}}</a></span>
                  <span class="ddc-margin-info"><a href="mailto:{{adherent?.email}}">{{adherent?.email}}</a></span>

                <div *ngIf="campAdherentSoutiensData[TypeSoutienEnum.INTERNATIONAL].length > 0" class="col-auto ddc-textfield-btn-div">

                  <button mat-raised-button class="mat-warn button-remove"
                          (click)="supprimeCampAdherentSoutien(adherent, TypeSoutienEnum.INTERNATIONAL)">
                    <i class="material-icons">remove_circle</i>
                  </button>
                </div>
          </div>
        </div>
        </div>
        </div>

        <div class="row ddc-padding-vertical"
             *ngIf="!currentUser.isCMPP && campAdherentSoutiensData[TypeSoutienEnum.INTERNATIONAL]?.length > 0">
          <div class="col-12 ddc-margin-auto">
            <div class="ddc-read-only-data-container">
              <span class="ddc-label">Soutiens département international : </span>
              <ng-container *ngFor="let adherents of campAdherentSoutiensData[TypeSoutienEnum.INTERNATIONAL]">
                <span class="ddc-value-read-only">
                  {{adherents?.prenom}} {{adherents?.nom}}
                </span>
              </ng-container>
            </div>
          </div>
        </div>

      </ng-container>
      <ng-container *ngIf="isCampModulesActive(currentCamp, [CampModuleEnum.MARIN]) || isCampModulesActive(campAdminstrationModules, [CampModuleEnum.MARIN])">
        <div class="row" *ngIf="currentUser.isCOMMAR">
          <div class="col-md-5">
            <div class="row">
              <mat-form-field floatLabel="always" class="col">
                <input matInput type="number" placeholder="COMMAR" [formControl]="codeEntryForm.get('marin')">
                <mat-hint>Entrez 9 chiffres</mat-hint>
                <mat-error ddcMatError [control]="codeEntryForm.get('marin')"></mat-error>
              </mat-form-field>

              <div class="col-auto ddc-textfield-btn-div">
                <button [disabled]="disableCodeSubmitButton(codeEntryForm.get('marin'))"
                        (click)="getAdherentByCode(TypeSoutienEnum.MARIN,codeEntryForm.get('marin'))"
                        type="button" mat-raised-button class="ddc-button-primary">
                  <i class="material-icons">search</i>
                </button>
              </div>
            </div>
          </div>

          <div class="col-md-7 ddc-margin-auto">
            <div class="row ddc-row-adherent-soutien" *ngFor="let adherent of campAdherentSoutiensData[TypeSoutienEnum.MARIN]; let i = index">
              <div *ngIf="campAdherentSoutiensData[TypeSoutienEnum.MARIN]?.length > 0" class="col ddc-margin-auto">
                {{adherent?.prenom}}
                {{adherent?.nom}}
                <span class="ddc-margin-info"><a href="tel:{{adherent?.telephonePortable}}">{{adherent?.telephonePortable}}</a></span>
                <span class="ddc-margin-info"><a href="mailto:{{adherent?.email}}">{{adherent?.email}}</a></span>
                <div *ngIf="campAdherentSoutiensData[TypeSoutienEnum.MARIN]?.length > 0" class="col-auto ddc-textfield-btn-div">

                  <button mat-raised-button class="mat-warn"
                          (click)="supprimeCampAdherentSoutien(adherent, TypeSoutienEnum.MARIN)">
                    <i class="material-icons">remove_circle</i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row ddc-padding-vertical"
             *ngIf="!currentUser.isCOMMAR && campAdherentSoutiensData[TypeSoutienEnum.MARIN]?.length > 0">
          <div class="col-12 ddc-margin-auto">
            <div class="ddc-read-only-data-container">
              <span class="ddc-label">COMMAR : </span>
              <ng-container *ngFor="let adherents of campAdherentSoutiensData[TypeSoutienEnum.MARIN]">
                <span class="ddc-value-read-only">
                  {{adherents?.prenom}} {{adherents?.nom}}
                </span>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="currentCamp.typeCamp.codeGroupeCamp === TypeCampGroupEnum.AUDACE">
        <div ddcLabel labelKey="appli.camp.onglet.infoGenerale.equipiers.vao.description" class="ddc-appli-description ddc-equiper-soutien-description-label"></div>
        <div class="row">
          <div *ngIf="currentUser.isEPANational === true" class="col-md-5">
            <div class="row">
              <mat-form-field floatLabel="always" class="col">
                <input matInput type="number" placeholder="Équipier VAO" [formControl]="codeEntryForm.get('vao')">
                <mat-hint>Entrez 9 chiffres</mat-hint>
                <mat-error ddcMatError [control]="codeEntryForm.get('vao')"></mat-error>
              </mat-form-field>

              <div class="col-auto ddc-textfield-btn-div">
                <button [disabled]="disableCodeSubmitButton(codeEntryForm.get('vao'))"
                        (click)="getAdherentByCode(TypeSoutienEnum.VAO,codeEntryForm.get('vao'))"
                        type="button" mat-raised-button class="ddc-button-primary">
                  <i class="material-icons">search</i>
                </button>
              </div>
            </div>
          </div>

          <div *ngIf="currentUser.isEPANational === true; else noEPANationalBlock" class="col-md-7 ddc-margin-auto">
            <div class="row ddc-row-adherent-soutien" *ngFor="let adherent of campAdherentSoutiensData[TypeSoutienEnum.VAO]; let i = index">
              <div *ngIf="campAdherentSoutiensData[TypeSoutienEnum.VAO]?.length > 0" class="col ddc-margin-auto">
                {{adherent.prenom}}
                {{adherent.nom}}
                <span class="ddc-margin-info"><a href="tel:{{adherent?.telephonePortable}}">{{adherent?.telephonePortable}}</a></span>
                <span class="ddc-margin-info"><a href="mailto:{{adherent?.email}}">{{adherent?.email}}</a></span>
                <div *ngIf="campAdherentSoutiensData[TypeSoutienEnum.VAO]?.length > 0 && currentUser.isEPANational === true" class="col-auto ddc-textfield-btn-div">

                  <button mat-raised-button class="mat-warn"
                          (click)="supprimeCampAdherentSoutien(adherent, TypeSoutienEnum.VAO)">
                    <i class="material-icons">remove_circle</i>
                  </button>
                </div>
              </div>
            </div>
          </div>

            <ng-template #noEPANationalBlock>
            <div class="row ddc-padding-vertical"
                 *ngIf="campAdherentSoutiensData[TypeSoutienEnum.VAO]?.length > 0">
                <div class="col-12 ddc-margin-auto">
                    <div class="ddc-read-only-data-container">
                        <span class="ddc-label">VAO : </span>
                        <ng-container *ngFor="let adherent of campAdherentSoutiensData[TypeSoutienEnum.VAO]">
                            <span class="ddc-value-read-only">
                                {{adherent?.prenom}} {{adherent?.nom}}
                            </span>
                        </ng-container>
                    </div>
                </div>
            </div>
            </ng-template>
        </div>
      </ng-container>
    </mat-card-content>
  </mat-card>

  <div class="row">
    <div class="col-12">
      <button mat-raised-button class="ddc-button-primary ddc-button-right"
              (click)="checkDatesAndSave()" id="save-button"
              [disabled]="(isSaving) || (this.campForm.invalid && this.formAlreadySubmitted)">
        Enregistrer
      </button>
    </div>
  </div>
</ddc-camp-onglet-body>

